import { takeLatest } from "redux-saga/effects";

import chatActionCreators from "../../actions/chat";
import sagasUtils from "../../../utils/sagas.utils";

export function* watchSyncCompanyMessages() {
  yield takeLatest(chatActionCreators.syncCompanyMessages.toString(), sagasUtils.syncMessages);
}
